/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientRegistrationActionPayload = {
    firstName: string;
    lastName: string;
    gender: ClientRegistrationActionPayload.gender;
};
export namespace ClientRegistrationActionPayload {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

